import { replaceFirst } from '../utils/replaceFirst'
import { frontOperatorValuesToAql } from '../utils/operatorValuesToAql'
import { regexpCaptureGroupsToSearchOperatorConfig } from '../utils/searchOperatorConfig'
import { YEAR_AQL_PATTERN } from '../../regexp'
import { YearOperator } from '../../enums'
import type { AllDashboardCardFilters } from '../../types'

export const parseYear = (aql: string): Pick<AllDashboardCardFilters, 'year' | 'yearLow' | 'yearHigh'> => {
    if (!aql) {
        return { year: '', yearLow: '', yearHigh: '' }
    }

    const regex = new RegExp(YEAR_AQL_PATTERN)
    const match = regex.exec(aql)

    const config = regexpCaptureGroupsToSearchOperatorConfig(match?.groups)
    const { operator, highValue, lowValue } = config

    return {
        year: operator as YearOperator,
        yearLow: lowValue,
        yearHigh: highValue,
    }
}

export const updateYear = (prior: string, operator: YearOperator | '' = '', lowValue = '', highValue = ''): string => {
    const updatedValue = frontOperatorValuesToAql({ operator, lowValue, highValue })
    return replaceFirst(prior, YEAR_AQL_PATTERN, updatedValue, { handleNotFound: 'prepend', removeOtherMatches: true })
}
